import * as Yup from 'yup'
import { useFormik } from 'formik'
import clsx from 'clsx'
import { useState } from 'react'
import { getPincodeDetail } from '../../../company-module/api'
import { handlePincodeChange } from '../../../component/pincode'
import { updateAddress } from '../../api'
import { swlAlert } from '../../../component'
import ConfirmPopup from './confirmPopup'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { goToLink } from '../../projectData'
import Swal from 'sweetalert2'


const editUserSchema = Yup.object().shape({
    pincode: Yup.number().required('Pincode is required'),
    city: Yup.string().trim().required('A Company city is required .'),
    state: Yup.string().trim().required('A Company state is required'),
    address1: Yup.string().trim().required('Address is required'),
    country: Yup.string().trim().required('A Company country is required'),
    address2: Yup.string().trim().required('Address is required'),
    // address3: Yup.string().required('Address is required'),
    landmark: Yup.string().trim().required('landmark is required'),
    district: Yup.string().trim().required('district is required'),
    address_type: Yup.string().required('address type is required'),
})

/**
 * RedemAddress component provides a form for users to add or edit their address for redemption.
 * Handles validation, confirmation popup, and address submission logic.
 */
export const RedemAddress = ({ isUserLoading, backFunction }) => {
    const { user_ref } = useParams()
    const navigate = useNavigate()
    const location = useLocation();

    const [countryData] = useState([{ value: 1, label: 'India' }])
    const [show, setShow] = useState(false);
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            address1: '',
            address2: '',
            address3: '',
            landmark: '',
            city: '',
            state: '',
            district: '',
            pincode: '',
            country: '1',
            address_type: '',
            user_code: user_ref,
            address_status_id: 4

        },
        validationSchema: editUserSchema,
        onSubmit: async (values, { setSubmitting }) => {
            setSubmitting(true);
            setShow(true); // Show confirmation modal


        },
    })
    const handleConfirm = async () => {
        const values = formik.values; // Get the form values from Formik

        try {
            let formData = new FormData();
            for (let value in values) {
                if (values[value] !== undefined && values[value] !== null) {
                    formData.append(value, values[value]);
                }
            }

            const response = await updateAddress(formData); // Call your API function
            if (response.code === 1) {
                Swal.fire({
                    title: response.message,
                    //text: dataMessage,
                    icon: "success",
                    //dangerMode: true,
                }).then(result => {
                    goToLink(navigate, `/customer/redem-detail/selectRedem-type/${user_ref}`, { itemValue: location.state?.itemValue })
                }).catch(error => {
                    console.error(error);
                });
            } else {
                swlAlert(response);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setShow(false); // Close the modal
        }
    };

    return (<>
        <div className="container">
            <form id="kt_form" className="form fv-plugins-bootstrap5 fv-plugins-framework  mt-4 mt-0 "
                onSubmit={formik.handleSubmit} noValidate>
                <div style={{ border: '1px solid #E6E6E6' }} className="card">
                    <div className="card-header" style={{ minHeight: '39px' }}>
                        <div className="card-title fw-semibold fs-5 py-1">Address
                        </div>
                    </div>
                    <div className="card-body p-4">
                        <div className='row mb-2 mt-2'>
                            <div className="col-lg-6 col-xl-6">
                                <div className='row'>
                                    <label className="col-lg-4 col-form-label required fw-semibold fs-6">House/Shop No.</label>

                                    <div className="col-lg-8 fv-row fv-plugins-icon-container">
                                        <input
                                            placeholder="Enter House/Shop No."
                                            {...formik.getFieldProps('address1')}
                                            type='text'
                                            onChange={formik.handleChange}
                                            name='address1'
                                            className={clsx(
                                                'form-control form-control-md rounded-0 mb-lg-0 mb-3',
                                                { 'is-invalid': formik.touched.address1 && formik.errors.address1 },
                                                { 'is-valid': formik.touched.address1 && !formik.errors.address1, }
                                            )}
                                            autoComplete='off'
                                            disabled={formik.isSubmitting || isUserLoading}
                                        />
                                        {formik.touched.address1 && formik.errors.address1 ? (
                                            <div className='fv-plugins-message-container'>
                                                <div className='fv-help-block'>
                                                    <span className='text-danger' role='alert'>{formik.errors.address1}</span>
                                                </div>
                                            </div>
                                        ) : <div className="text-muted fs-7"></div>}
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-xl-6">
                                <div className='row'>
                                    <label className="col-lg-4 col-form-label required fw-semibold fs-6">Market/Society</label>
                                    <div className="col-lg-8 fv-row fv-plugins-icon-container">
                                        <input
                                            placeholder="Enter Market/Society "
                                            {...formik.getFieldProps('address2')}
                                            type='text'
                                            onChange={formik.handleChange}
                                            name='address2'
                                            className={clsx(
                                                'form-control form-control-md rounded-0 mb-lg-0 mb-3',
                                                { 'is-invalid': formik.touched.address2 && formik.errors.address2 },
                                                { 'is-valid': formik.touched.address2 && !formik.errors.address2, }
                                            )}
                                            autoComplete='off'
                                            disabled={formik.isSubmitting || isUserLoading}
                                        />

                                        {formik.touched.address2 && formik.errors.address2 ? (
                                            <div className='fv-plugins-message-container'>
                                                <div className='fv-help-block'>
                                                    <span className='text-danger' role='alert'>{formik.errors.address2}</span>
                                                </div>
                                            </div>
                                        ) : <div className="text-muted fs-7"></div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='row mb-2'>
                            <div className="col-lg-6 col-xl-6">
                                <div className='row'>
                                    <label className="col-lg-4 col-form-label  fw-semibold fs-6">Area</label>
                                    <div className="col-lg-8 fv-row fv-plugins-icon-container">
                                        <input
                                            placeholder="Enter Area"
                                            {...formik.getFieldProps('address3')}
                                            type='text'
                                            onChange={formik.handleChange}
                                            name='address3'
                                            className={clsx(
                                                'form-control form-control-md rounded-0 mb-lg-0 mb-3',
                                                { 'is-invalid': formik.touched.address3 && formik.errors.address3 },
                                                { 'is-valid': formik.touched.address3 && !formik.errors.address3, }
                                            )}
                                            autoComplete='off'
                                            disabled={formik.isSubmitting || isUserLoading}
                                        />
                                        {formik.touched.address3 && formik.errors.address3 ? (
                                            <div className='fv-plugins-message-container'>
                                                <div className='fv-help-block'>
                                                    <span className='text-danger' role='alert'>{formik.errors.address3}</span>
                                                </div>
                                            </div>
                                        ) : <div className="text-muted fs-7"></div>}
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-xl-6">
                                <div className='row'>
                                    <label className="col-lg-4 col-form-label  fw-semibold fs-6">Landmark</label>
                                    <div className="col-lg-8 fv-row fv-plugins-icon-container">
                                        <input
                                            placeholder="Enter Landmark"
                                            {...formik.getFieldProps('landmark')}
                                            type='text'
                                            onChange={formik.handleChange}
                                            name='landmark'
                                            className={clsx(
                                                'form-control form-control-md rounded-0 mb-lg-0 mb-3',
                                                { 'is-invalid': formik.touched.landmark && formik.errors.landmark },
                                                { 'is-valid': formik.touched.landmark && !formik.errors.landmark, }
                                            )}
                                            autoComplete='off'
                                            disabled={formik.isSubmitting || isUserLoading}
                                        />
                                        {formik.touched.landmark && formik.errors.landmark ? (
                                            <div className='fv-plugins-message-container'>
                                                <div className='fv-help-block'>
                                                    <span className='text-danger' role='alert'>{formik.errors.landmark}</span>
                                                </div>
                                            </div>
                                        ) : <div className="text-muted fs-7"></div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='row mb-2'>
                            <div className="col-lg-6 col-xl-6">
                                <div className='row'>
                                    <label className="col-lg-4 col-form-label required fw-semibold fs-6">City</label>
                                    <div className="col-lg-8 fv-row fv-plugins-icon-container">
                                        <input
                                            placeholder="Enter City"
                                            {...formik.getFieldProps('city')}
                                            type='text'
                                            onChange={formik.handleChange}
                                            name='city'
                                            className={clsx(
                                                'form-control form-control-md rounded-0 mb-lg-0 mb-3',
                                                { 'is-invalid': formik.touched.city && formik.errors.city },
                                                { 'is-valid': formik.touched.city && !formik.errors.city, }
                                            )}
                                            autoComplete='off'
                                            disabled={formik.isSubmitting || isUserLoading}
                                        />
                                        {formik.touched.city && formik.errors.city ? (
                                            <div className='fv-plugins-message-container'>
                                                <div className='fv-help-block'>
                                                    <span className='text-danger' role='alert'>{formik.errors.city}</span>
                                                </div>
                                            </div>
                                        ) : <div className="text-muted fs-7"></div>}
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-xl-6">
                                <div className='row'>
                                    <div className='col-lg-4 '>
                                        <div className='d-flex '>
                                            <label className="col-form-label required fw-semibold fs-6">
                                                Pincode
                                            </label>

                                        </div>
                                    </div>
                                    <div className="col-lg-8 fv-row fv-plugins-icon-container">
                                        <div className="input-group mb-3">
                                            <input
                                                placeholder="Enter Pincode"
                                                type="text"
                                                onChange={(e) => handlePincodeChange(formik, getPincodeDetail, e)}
                                                name="pincode"
                                                className={`form-control form-control-md rounded-0 mb-lg-0 mb-3 ${formik.touched.pincode && formik.errors.pincode
                                                    ? 'is-invalid'
                                                    : formik.touched.pincode && !formik.errors.pincode
                                                        ? 'is-valid'
                                                        : ''
                                                    }`}
                                                autoComplete="off"
                                                disabled={formik.isSubmitting || isUserLoading}
                                            />
                                        </div>
                                        {formik.values.pincode_reponse &&
                                            <div className={formik.values.pincode_reponse === "success" ? "text-success" : "text-danger"}>{formik.values.pincode_reponse}</div>
                                        }
                                        {formik.touched.pincode && formik.errors.pincode ? (
                                            <div className='fv-plugins-message-container'>
                                                <div className='fv-help-block'>
                                                    <span className='text-danger' role='alert'>{formik.errors.pincode}</span>
                                                </div>
                                            </div>
                                        ) : <div className="text-muted fs-7"></div>}
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className='row mb-2'>
                            <div className="col-lg-6 col-xl-6">
                                <div className='row'>
                                    <label className="col-lg-4 col-form-label required fw-semibold fs-6">District</label>
                                    <div className="col-lg-8 fv-row fv-plugins-icon-container">
                                        <input
                                            placeholder="Enter district"
                                            {...formik.getFieldProps('district')}
                                            type='text'
                                            onChange={formik.handleChange}
                                            name='district'
                                            className={clsx(
                                                'form-control form-control-md rounded-0 mb-lg-0 mb-3',
                                                { 'is-invalid': formik.touched.district && formik.errors.district },
                                                { 'is-valid': formik.touched.district && !formik.errors.district, }
                                            )}
                                            autoComplete='off'
                                            disabled={formik.isSubmitting || isUserLoading}
                                        />
                                        {formik.touched.district && formik.errors.district ? (
                                            <div className='fv-plugins-message-container'>
                                                <div className='fv-help-block'>
                                                    <span className='text-danger' role='alert'>{formik.errors.district}</span>
                                                </div>
                                            </div>
                                        ) : <div className="text-muted fs-7"></div>}
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-xl-6">
                                <div className='row'>
                                    <label className="col-lg-4 col-form-label required fw-semibold fs-6">State</label>
                                    <div className="col-lg-8 fv-row fv-plugins-icon-container">
                                        <input
                                            placeholder="Enter State"
                                            {...formik.getFieldProps('state')}
                                            type='text'
                                            onChange={formik.handleChange}
                                            name='state'
                                            className={clsx(
                                                'form-control form-control-md rounded-0 mb-lg-0 mb-3',
                                                { 'is-invalid': formik.touched.state && formik.errors.state },
                                                { 'is-valid': formik.touched.state && !formik.errors.state, }
                                            )}
                                            autoComplete='off'
                                            disabled={formik.isSubmitting || isUserLoading}
                                        />
                                        {formik.touched.state && formik.errors.state ? (
                                            <div className='fv-plugins-message-container'>
                                                <div className='fv-help-block'>
                                                    <span className='text-danger' role='alert'>{formik.errors.state}</span>
                                                </div>
                                            </div>
                                        ) : <div className="text-muted fs-7"></div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='row mb-2'>
                            <div className="col-lg-6 col-xl-6">
                                <div className='row'>
                                    <label className="col-lg-4 col-form-label required fw-semibold fs-6">Country</label>
                                    <div className="col-lg-8 fv-row fv-plugins-icon-container">
                                        <select
                                            className="form-control form-control-md rounded-0 mb-lg-0 mb-3"
                                            {...formik.getFieldProps('country')}
                                            name="country"
                                        >
                                            <option>Select</option>
                                            {countryData && countryData.map((contry) => {

                                                return <option key={contry.value} value={contry.value}>{contry.label}</option>
                                            })}
                                        </select>
                                        {formik.touched.country && formik.errors.country ? (
                                            <div className='fv-plugins-message-container'>
                                                <div className='fv-help-block'>
                                                    <span className='text-danger' role='alert'>{formik.errors.country}</span>
                                                </div>
                                            </div>
                                        ) : <div className="text-muted fs-7">  </div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12 col-xl-12">
                            <div className='row'>
                                <label className="col-lg-4 col-form-label required fw-semibold fs-6">Save Address As</label>
                                <div className='col-4'>
                                    <div className={`card ${formik.values.address_type === 'home' ? 'border border-success' : 'border rounded'}  p-3`} onClick={() => formik.setFieldValue('address_type', 'home')}>
                                        <div className='row ' >
                                            <span className='col-3'><i className={`fas fa-home fs-1 ${formik.values.address_type === 'home' ? 'text-success' : ''}`}></i></span>
                                            <span className='col-9 '>Home </span>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-4'>
                                    <div className={`card ${formik.values.address_type === 'office' ? 'border border-success' : 'border rounded'}  p-3`} onClick={() => formik.setFieldValue('address_type', 'office')}>
                                        <div className='row ' >
                                            <span className='col-3'>  <i className={`fas fa-building fs-1 ${formik.values.address_type === 'office' ? 'text-success' : ''}`}></i></span>
                                            <span className='col-9 '>Office </span>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-4'>
                                    <div className={`card ${formik.values.address_type === 'other' ? 'border border-success' : 'border rounded'}  p-3`} onClick={() => formik.setFieldValue('address_type', 'other')}>
                                        <div className='row ' >
                                            <span className='col-4'>  <i className={`fas fa-ellipsis-h fs-1 ${formik.values.address_type === 'other' ? 'text-success' : ''}`}></i></span>
                                            <span className='col-8 '>Other </span>
                                        </div>
                                    </div>
                                </div>
                                {formik.touched.address_type && formik.errors.address_type ? (
                                    <div className='fv-plugins-message-container'>
                                        <div className='fv-help-block'>
                                            <span className='text-danger' role='alert'>{formik.errors.address_type}</span>
                                        </div>
                                    </div>
                                ) : <div className="text-muted fs-7"></div>}
                            </div>
                        </div>
                    </div>
                    <div className='card-footer py-2'>
                        <div className="d-flex justify-content-end">
                            <button type="button" onClick={() => navigate(-1)} id="kt_ecommerce_add_Company_submit" className="btn btn-secondary me-2"
                            // disabled={formik.isSubmitting || !formik.isValid}
                            >
                                <span className="indicator-label">Cancel</span>
                                {(formik.isSubmitting) && <span className="indicator-progress">Please wait...
                                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span>}
                            </button>
                            <button type="onclick" id="kt_ecommerce_add_Company_submit" className="btn btn-primary"
                            // disabled={formik.isSubmitting || !formik.isValid}
                            >
                                <span className="indicator-label">{formik?.values?.id ? "Update " : "Save "}</span>
                                {(formik.isSubmitting) && <span className="indicator-progress">Please wait...
                                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span>}
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <ConfirmPopup show={show} setShow={setShow} item={formik?.values} onConfirm={handleConfirm} />
    </>
    )
}











